import { ImgLoader } from "../CoalitionComplements";
import { showOnlyIfNotProd, printableId } from "../../utils";
import { stars_count } from "../../pngs";
import "./CoalitionCardStars.scss";

export const CoalitionCardStars = ({ card = {}, promoClicked }) => {
  const {
    mobile_image,
    desktop_image,
    short_title,
    title,
    display_start_date,
    offer_id,
  } = card;
  const now = new Date(Date.now());
  const show = new Date(display_start_date);

  return (
    <>
      {now >= show ? (
        <div
          className="stars-card"
          onClick={promoClicked}
          onKeyPress={promoClicked}
          role="button"
          tabIndex={0}
        >
          <ImgLoader mobile={mobile_image} desktop={desktop_image} />
          <PromoTitle text={short_title ?? title} />
          <TagDrawer card={card} />
          {showOnlyIfNotProd(
            <label className="qa-detail">{printableId(offer_id)}</label>
          )}
        </div>
      ) : null}
    </>
  );
};

const PromoTitle = ({ text, limit = 22 }) => {
  const title = text.length >= limit ? `${text.slice(0, limit)} ...` : text;
  return <div className="promo-title">{title}</div>;
};

const TagDrawer = ({ card, label, klass }) => {
  const {
    display_start_date, // show
    start_date, // participate
    end_date, // checkWinners
    points, // if points, enrolled and receiving stars
    winners,
  } = card;
  const enrolled = points !== undefined;
  const stars = !enrolled ? null : !points ? 0 : points;

  const now = new Date(Date.now());
  const show = new Date(display_start_date);
  const participate = new Date(start_date);
  const checkWinners = new Date(end_date);

  let showStar = false;

  if (winners && winners.length > 0) {
    label = "Entérate si ganaste 🏆";
    klass = "winner-check";
  } else if (checkWinners && now >= checkWinners) {
    label = "Espera resultado ⏰";
    klass = "winner-pending";
  } else if (enrolled) {
    label = `${stars} estrellas`;
    klass = "enrolled";
    showStar = true;
  } else if (now >= show && now >= participate) {
    label = "Participa ahora 🎉";
    klass = "enroll-now";
  } else {
    label = "Muy pronto 🤩";
    klass = "comming-soon";
  }

  return (
    <>
      <div className={`promo-status ${klass}`}>
        <label>
          {showStar && <img src={stars_count} alt="# stars" />}
          {label}
        </label>
      </div>
    </>
  );
};
